// ============================================================
// TABELLONI PUBBLICITARI (video e/o immagini)
//
// COME AGGIUNGERE UN CONTENUTO (nessun codice da scrivere se non
// l'URL):
//  1. Shopify admin → Contenuto → File → Carica file
//     Video: H.264/mp4, 720p, < 15 MB, meglio senza audio (i
//     browser bloccano l'autoplay con audio: i tabelloni sono MUTI).
//     Immagini: jpg/png/webp, lato lungo ~1600px.
//  2. Clicca il file caricato → copia il link, tipo
//     https://cdn.shopify.com/s/files/1/0942/.../spot.mp4?v=123
//  3. Incollalo nel campo `media` qui sotto.
//  4. Calibra posizione/dimensione col pannello Leva (?debug →
//     "Pubblicità") e riporta qui i valori trovati.
//
// UN SOLO CONTENUTO: `media: 'https://...'`
// PIÙ CONTENUTI (playlist): `media: ['https://...', 'https://...']`
//   → si susseguono in loop. Si possono MESCOLARE video e immagini:
//     i video durano quanto il filmato, le immagini restano a
//     schermo `durataImmagine` secondi (default 6).
//
// PIÙ TABELLONI: aggiungi altri oggetti a questa lista, ognuno col
// suo `nome` (unico: dà il nome alla cartella degli slider Leva).
//
// COME APPARE (campo `stile`, opzionale):
//  • 'auto' (default) → con 2-3 IMMAGINI usa le LAMELLE (trivision:
//    lamelle verticali che ruotano a onda, come i cartelloni
//    stradali); negli altri casi (video, o più di 3 contenuti) usa
//    lo schermo PIATTO con playlist.
//  • 'lamelle' / 'piatto' per forzare una modalità.
// `lamelle: 12` = quante lamelle (più lamelle = effetto più fine ma
// qualche draw call in più; 8-16 è la fascia sensata).
//
// In alternativa ai File puoi usare l'URL di un media già caricato
// su un PRODOTTO (mp4 o foto): funziona uguale.
// ============================================================

export const TABELLONI = [
  {
    nome: 'ingresso',
    // ⬇️ vuoto = tabellone non mostrato
    // I tre manifesti della mascotte (2752x1536 in originale). Il
    // suffisso &width=1400 fa ridimensionare l'immagine ALLA CDN di
    // Shopify: stesso risultato a schermo, ma un terzo della memoria
    // video e del peso scaricato (3.6 MB → 1.1 MB a manifesto).
    media: [
      'https://cdn.shopify.com/s/files/1/0942/2900/4630/files/Gemini_Generated_Image_fa156ifa156ifa15.png?v=1786430894&width=1400',
      'https://cdn.shopify.com/s/files/1/0942/2900/4630/files/Gemini_Generated_Image_o3uacso3uacso3ua.png?v=1786430896&width=1400',
      'https://cdn.shopify.com/s/files/1/0942/2900/4630/files/Gemini_Generated_Image_ivt7vwivt7vwivt7.png?v=1786430897&width=1400',
    ],
    // posizione e misure tarate dall'utente coi cursori (2026-09-16)
    position: [4.35, 4.05, -11.10], // muro Est, sopra gli scaffali
    rotationY: 0,                 // 0 = fronte verso z+ (dentro il negozio)
    // larghezza/altezza = ingombro della CORNICE: ogni contenuto ci si
    // adatta dentro mantenendo le sue proporzioni (bande scure ai lati
    // o sopra/sotto, come su uno schermo vero)
    larghezza: 6.25,
    altezza: 3.53,                // 6.25/3.53 = 1.77, contro l'1.79 dei
                                  //   manifesti: restano bande scure di un
                                  //   paio di pixel, invisibili
    stile: 'auto',                // 'auto' | 'lamelle' | 'piatto'
    lamelle: 12,                  // numero di lamelle (modalità trivision)
    durataImmagine: 6,            // secondi tra un manifesto e il successivo
    // Oltre questa distanza il tabellone va in pausa: decodificare
    // video costa, e da lontano non si distingue comunque
    distanzaMax: 22,
  },

  // Secondo tabellone, con playlist mista foto + video: togli i
  // commenti e incolla gli URL per attivarlo
  // {
  //   nome: 'cassa',
  //   media: [
  //     'https://cdn.shopify.com/s/files/.../promo.jpg',
  //     'https://cdn.shopify.com/s/files/.../spot.mp4',
  //   ],
  //   position: [6.2, 3.0, -5.4],
  //   rotationY: Math.PI / 2,
  //   larghezza: 3,
  //   altezza: 1.7,
  //   durataImmagine: 5,
  //   distanzaMax: 18,
  // },
]

// Normalizza il campo `media` (stringa o array) in una lista di URL
// validi. Accetta anche il vecchio nome `video`. Usata da Billboard.jsx.
export function listaMedia(tabellone) {
  const v = tabellone.media ?? tabellone.video
  return (Array.isArray(v) ? v : [v]).filter(Boolean)
}

// Tipo di contenuto dall'estensione, ignorando la query string
// (gli URL Shopify finiscono con ?v=123456)
export function isImmagine(url) {
  return /\.(jpg|jpeg|png|webp|avif|gif)$/i.test(url.split('?')[0])
}
